import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { formatCountdown } from '../../../lib/helpers/date.helpers';
import { IntlMsg } from '../IntlMsg/intl-msg.component';
import { messages } from './idle-sign-out.messages';

interface IIdleWarningDialogProps {
  remainingMs: number;
  onStaySignedIn: () => void;
}

// Dismissing the dialog any way (backdrop, Escape) counts as activity, so it only ever keeps the session.
export const IdleWarningDialog: React.FC<IIdleWarningDialogProps> = ({ remainingMs, onStaySignedIn }) => (
  <Dialog open onClose={onStaySignedIn} maxWidth="xs" fullWidth>
    <DialogTitle>
      <IntlMsg {...messages.warningTitle} />
    </DialogTitle>
    <DialogContent>
      <DialogContentText>
        <IntlMsg {...messages.warningBody} values={{ countdown: formatCountdown(remainingMs) }} />
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onStaySignedIn} color="primary" variant="contained" autoFocus>
        <IntlMsg {...messages.btnStaySignedIn} />
      </Button>
    </DialogActions>
  </Dialog>
);
